import { useCallback, useEffect, useState } from 'react';
import { useSessionContext } from '@/auth/useSessionContext';
import { useImpersonation } from '@/contexts/ImpersonationContext';
import useConfirmedUserTrigger from '@/hooks/useConfirmedUserTrigger';
import { shouldPromptCreatePassword } from '@/hooks/useShouldPromptCreatePassword';
import CreatePasswordModal from '@/sections/auth/CreatePasswordModal';

const shouldTrigger = (currentUser) =>
  shouldPromptCreatePassword({ isInitialized: true, user: currentUser });

export default function CreatePasswordPrompt() {
  const { user, isInitialized, refreshUser } = useSessionContext();
  const { impersonatedUserId } = useImpersonation() || {};
  const [open, setOpen] = useState(false);

  // Impersonando, o backend recusa o create-password (BlockImpersonateActions): o modal
  // não fecha e prenderia quem impersona sem saída. A senha é do dono, não de quem entra na conta.
  const { shouldRunTrigger } = useConfirmedUserTrigger({
    enabled: !impersonatedUserId,
    isInitialized,
    user,
    refreshUser,
    shouldTrigger,
    triggerKey: `create-password:${user?.id || user?.email || 'current'}`,
  });

  useEffect(() => {
    setOpen(shouldRunTrigger);
  }, [shouldRunTrigger]);

  // Só o formulário fecha, com `false` depois de criar a senha. Esc e clique fora chegam com o
  // evento, e a conta sem senha não pode seguir pelo painel.
  const handleClose = useCallback((value) => {
    if (value === false) setOpen(false);
  }, []);

  if (!open) return null;

  return <CreatePasswordModal open handleClose={handleClose} />;
}
